<template>
  <div class="col-12 c g">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <table class="table table-hover table-bordered table-sm">
                <thead>
                    <th>
                        التاريخ
                    </th>
                    <th>
                        الحالة
                    </th>
                    <th>
                        التوقيت
                    </th>
                    <th>
                        طريقة التحضير
                    </th>
                </thead>
                <tbody>
                    <tr v-for="report in reports" :key="report._id">
                        <td>
                            {{ report.date }}
                        </td>
                        <td>
                            <span class="badge badge-secondary" v-if="report.status == 0"
                            >خارج وقت الدوام</span
                            >
                            <span class="badge badge-success" v-if="report.status == 1"
                            >حاضر</span
                            >
                            <span class="badge badge-warning lated" v-if="report.status == 2"
                            >متأخر</span
                            >
                            <div v-if="report.status == 2 && report.late_time > 0">
                            متأخر: {{ report.late_time }} دقيقة ({{
                                (report.late_time / 60).toFixed(1)
                            }}
                            ساعة)
                            </div>
                            <span class="badge badge-danger" v-if="report.status == 3"
                            >غائب</span
                            >
                            <span class="badge badge-info" v-if="report.status == 6"
                            >اجازة</span
                            >
                            <span class="badge badge-primary" v-if="report.status == 5"
                            >غائب بعذر</span
                            >
                            <div v-if="report.reason">
                                {{ report.reason }}
                            </div>
                        </td>
                        <td>
                            {{ report.time }}
                        </td>
                        <td>
                            {{ report.from.replace("manual", "يدوياً").replace("barcode", "باركود").replace("fp", "البصمة")
                            .replace("bulk", "تحضير جماعي")
                            .replace("auto-generated", "")
                             }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BFormCheckbox,
    },
    directives: {
        Ripple,
    },
    data(){
        return {
            teacher: JSON.parse(localStorage.getItem('teacher')),
            reports: [],
            minutes: 0
        }
    },
    created(){
        var g = this;
        var date = new Date();
        date.setDate(date.getDate() - 30);
        $.post(api + '/teacher/myreport', {
            username: this.teacher.username,
            password: this.teacher.password,
            from: date.toISOString().split('T')[0],
            to: new Date().toISOString().split('T')[0]
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.reports = r.response.reports;
                g.minutes = r.response.minutes;
            }
        }).fail(function(){
        })
    },
    methods: {
    }
}
</script>

<style>
.classroom{
    padding: 15px; 
    border: 2px solid #ddd;
    border-radius: 5px;
}
.classroom:hover{
    background: #fafafa !important;
    cursor: pointer;
    border: 2px solid #333;
}
</style>